import { render } from "./ProductSubseven.vue?vue&type=template&id=e90b85fa&scoped=true"
import script from "./ProductSubseven.vue?vue&type=script&lang=js"
export * from "./ProductSubseven.vue?vue&type=script&lang=js"

import "./ProductSubseven.vue?vue&type=style&index=0&id=e90b85fa&scoped=true&lang=css"
import "./ProductSubseven.vue?vue&type=style&index=1&id=e90b85fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e90b85fa"]])

export default __exports__